export default __webpack_public_path__ + "static/media/anniversarymobile3.055faa1c.webp";